import { ApiError } from "@core/api/api-error";
import { HealthcareTeamErrorCodes } from "@domain/healthcare-team/healthcare-team-errors";
import { Signal } from "micro-signals";

export class ErrorManager {
	onPtNotInHealthcareTeam = new Signal<void>();

	handleCustomApiError(error: ApiError): void {
		if (error.code === HealthcareTeamErrorCodes.PtNotInHealthcareTeam) {
			this.onPtNotInHealthcareTeam.dispatch();
		}
	}
}
